import React, { useRef } from 'react';
import LandingPage from './LandingPage';
import Map from './Map/Map';
import InfoBox from './InfoBox';
import { useTranslation } from 'react-i18next';
import Steps from './Steps';
import FAQ from './FAQ';
import CooperativeDistricts from './CooperatingDistricts';

export default function Home() {
    const { t } = useTranslation();
    const mapRef = useRef<HTMLDivElement>(null);

    return (
        <div>
            <LandingPage
            scrollToReport={() =>
                mapRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                })
            }
            />
            <FAQ />
            <CooperativeDistricts />
            <div className={'margin-home bg-white'}>
            <InfoBox title={t('MAIN_PAGE.INFO_BOX.HOW_TO_USE_MAP_TITLE')} className={'my-10'}>
                {t('MAIN_PAGE.INFO_BOX.HOW_TO_USE_MAP_CONTENT')}
            </InfoBox>

            <div className={'px-0 sm:px-10'} ref={mapRef}>
                <Map className={'h-[600px] w-full'} urlReportEnabled />
            </div>
            </div>
            <Steps />
        </div>
    );
}
